import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_find_carriersService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { carriers?: { name?: string, shortName?: string, scacCode?: string }[] }): 
  Promise<{ result: { Id?: number, Name?: string, ScacCode?: string, ShortName?: string, Services?: { ServiceTypeId?: number, ServiceType?: { Name?: string, ShortName?: string } }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { carriers?: { name?: string, shortName?: string, scacCode?: string }[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Name?: string, ScacCode?: string, ShortName?: string, Services?: { ServiceTypeId?: number, ServiceType?: { Name?: string, ShortName?: string } }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { carriers?: { name?: string, shortName?: string, scacCode?: string }[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Name?: string, ScacCode?: string, ShortName?: string, Services?: { ServiceTypeId?: number, ServiceType?: { Name?: string, ShortName?: string } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      carriers?: { name?: string, shortName?: string, scacCode?: string }[]    }) {
      return false;
    }
}
